import { useCopilotKit } from '@copilotkit/react-core/v2'
import { useEffect, useState } from 'react'
import { CallBackForm } from '../components/AI/CallBackForm'
import { EmailContactForm } from '../components/AI/EmailContactForm'

type Choice = 'none' | 'email' | 'call'

function ShowEmailFormRenderer({
  status,
  args,
}: {
  status: string
  args: { to?: string; suggestedSubject?: string; suggestedSummary?: string }
}) {
  const [choice, setChoice] = useState<Choice>('none')
  const [done, setDone] = useState(false)
  const [doneLabel, setDoneLabel] = useState('')

  if (status === 'inProgress') return null

  if (done) {
    return (
      <div className='my-3 rounded-lg border border-light-dark-gray bg-lightest-gray px-4 py-3 text-sm text-medium-dark-gray'>
        {doneLabel}
      </div>
    )
  }

  if (choice === 'email') {
    return (
      <EmailContactForm
        to={args?.to}
        suggestedSubject={args?.suggestedSubject}
        suggestedSummary={args?.suggestedSummary}
        respond={() => {
          setDoneLabel('Thank you. We\'ll get back to you as soon as possible.')
          setDone(true)
          return Promise.resolve()
        }}
      />
    )
  }

  if (choice === 'call') {
    return (
      <CallBackForm
        suggestedSubject={args?.suggestedSubject}
        respond={() => {
          setDoneLabel('Thank you. We\'ll get back to you as soon as possible.')
          setDone(true)
          return Promise.resolve()
        }}
      />
    )
  }

  return (
    <div className='my-3 flex flex-col gap-3 rounded-[12px] border border-light-dark-gray bg-lightest-gray/50 px-4 py-4'>
      <p className='text-sm font-medium text-tight-black'>How can we reach you?</p>
      <div className='flex gap-3'>
        <button
          type='button'
          onClick={() => setChoice('email')}
          className='flex flex-1 flex-col items-center gap-1.5 rounded-[12px] border border-light-dark-gray px-4 py-3 transition-colors hover:border-bright-templi-purple hover:bg-lighter-templi-purple/20'
        >
          <span className='text-2xl'>✉️</span>
          <span className='text-sm font-medium'>Email</span>
        </button>
        <button
          type='button'
          onClick={() => setChoice('call')}
          className='flex flex-1 flex-col items-center gap-1.5 rounded-[12px] border border-light-dark-gray px-4 py-3 transition-colors hover:border-bright-templi-purple hover:bg-lighter-templi-purple/20'
        >
          <span className='text-2xl'>📞</span>
          <span className='text-sm font-medium'>Call</span>
        </button>
      </div>
    </div>
  )
}

export function useShowEmailFormAction() {
  const { copilotkit } = useCopilotKit()
  useEffect(() => {
    const core = copilotkit as { addHookRenderToolCall: (r: object) => void }
    core.addHookRenderToolCall({
      name: 'showEmailForm',
      args: null,
      render: ShowEmailFormRenderer,
    })
  }, [copilotkit])
}
